import type { AppConfig } from '@shared/types';
import { api } from './api';

/** Admin API wrapper for the Remote Config page (#344). */

/**
 * Fetch the current AppConfig via the authenticated admin endpoint. Uses
 * `/admin/config` rather than the public `/api/config` so admin SPA pageloads
 * don't share the 60/min/IP public-read rate limit with mobile clients on
 * the same egress NAT.
 */
export async function getAppConfig(): Promise<AppConfig> {
  return api<AppConfig>('/admin/config');
}

/** Shape of the PATCH /api/admin/config body — all fields are deeply optional. */
export type AppConfigPatch = DeepPartial<
  Omit<AppConfig, 'version' | 'updatedAt'>
>;

type DeepPartial<T> = T extends object
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : T;

/** Apply a patch via the admin-gated PATCH endpoint. Bumps `version`. */
export async function updateAppConfig(
  patch: AppConfigPatch
): Promise<AppConfig> {
  return api<AppConfig>('/admin/config', {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}
